import { Outlet } from "react-router-dom"

const TiketUserModule = () => {
    return <Outlet />
}
export  default TiketUserModule